<template>
  <base-card :loading="$store.state.loading.length > 0" class="mx-auto">
    <base-card>
      <BuildingImage />
    </base-card>
    <v-card-text>
      <div class="text-subtitle-1">
        <div class="d-flex justify-space-between">
          <div>
            <div>
              {{ $t($store.getters.apartment.title) }} {{ $store.getters.apartment.number }}
            </div>
          </div>

          <div class="floor-plan-dialog">
            <v-dialog
              v-model="floorPlanDialog"
              width="700"
              v-if="$store.getters.apartment.floor_plan"
            >
              <template v-slot:activator="{ on }">
                <v-btn outlined text tile v-on="on" small>
                  <v-icon left>mdi-floor-plan</v-icon>
                  <span v-t="'Floor plan'" />
                </v-btn>
              </template>
              <v-card>
                <v-img :src="$store.getters.apartment.floor_plan">
                  <v-btn @click="floorPlanDialog = false" x-small icon class="float-right white">
                    <v-icon color="black">mdi-close</v-icon>
                  </v-btn>
                </v-img>
              </v-card>
            </v-dialog>
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div>
            {{ $store.state.floor + $t(". floor") }}
          </div>
          <span class="mx-2">•</span>

          <div>
            {{ $t("{0} rooms", [$store.getters.apartment.rooms]) }}
          </div>
          <span class="mx-2">•</span>

          <div>
            <span v-if="$store.getters.apartment.bathrooms.length === 1">
              <span v-t="'1 bathroom'" />
            </span>
            <span v-else>
              {{ $t("{0} bathrooms", [$store.getters.apartment.bathrooms.length]) }}
            </span>
          </div>
        </div>
      </div>
    </v-card-text>
    <slot></slot>
  </base-card>
</template>
<script>
import BuildingImage from "./BuildingImage";
export default {
  components: {
    BuildingImage,
  },
  data() {
    return {
      floorPlanDialog: null,
    };
  },

  computed: {
    building() {
      return this.$store.getters.building;
    },
  },
};
</script>
